<div class="max-w-2xl mx-auto p-6 space-y-6">
  <div class="flex items-center justify-between mb-4">
    <button
      type="button"
      (click)="goBack()"
      class="flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors"
    >
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
      </svg>
      Back
    </button>
    <h1 class="text-2xl font-semibold">{{ isEditMode() ? 'Edit News' : 'Create News' }}</h1>
    <div></div>
  </div>

  <form [formGroup]="form" class="space-y-4">
    <div>
      <label for="title" class="block mb-1 font-medium">Title</label>
      <input
        id="title"
        type="text"
        formControlName="title"
        class="w-full rounded-md border px-3 py-2 placeholder-gray-500 focus:outline-none focus:ring focus:ring-blue-300"
        placeholder="Enter title"
      />
      @if (f.title.touched && f.title.invalid) {
        <div class="text-sm text-red-600 mt-1">
          Title is required (min 3 chars).
        </div>
      }
    </div>

    <div>
      <label for="summary" class="block mb-1 font-medium">Summary</label>
      <textarea
        id="summary"
        formControlName="summary"
        rows="3"
        class="w-full rounded-md border px-3 py-2 placeholder-gray-500 focus:outline-none focus:ring focus:ring-blue-300 resize-none"
        placeholder="Short summary (max 200 chars)"
      ></textarea>
      <div class="flex justify-between text-xs text-gray-500 mt-1">
        @if (f.summary.touched && f.summary.invalid) {
          <span class="text-red-600">Summary required.</span>
        } @else {
          <span></span>
        }
        <span>{{ f.summary.value.length }}/200</span>
      </div>
    </div>

    <div>
      <label for="content" class="block mb-1 font-medium">Content</label>
      <textarea
        id="content"
        formControlName="content"
        rows="8"
        class="w-full rounded-md border px-3 py-2 placeholder-gray-500 focus:outline-none focus:ring focus:ring-blue-300"
        placeholder="Full content"
      ></textarea>
      @if (f.content.touched && f.content.invalid) {
        <div class="text-sm text-red-600 mt-1">
          Content required (min 10 chars).
        </div>
      }
    </div>

    <div>
      <label for="images" class="block mb-1 font-medium">Images</label>
      <input
        #fileInput
        id="images"
        type="file"
        multiple
        accept="image/*"
        (change)="onFilesSelected($event)"
        class="w-full rounded-md border px-3 py-2 focus:outline-none focus:ring focus:ring-blue-300 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
      />
      
      <app-news-image-list
        [previews]="imagePreviews()"
        (remove)="onRemoveImage($event)"
        (reorder)="onReorderImages($event)"
      />
    </div>

    <div class="flex justify-end gap-3">
      @if (isEditMode()) {
        <button
          type="button"
          (click)="delete()"
          [disabled]="isDeleting() || isUploading()"
          class="px-8 py-2 bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium rounded-md hover:bg-red-700 transition"
        >
          {{ isDeleting() ? 'Deleting...' : 'Delete' }}
        </button>
      }
      <button
        type="button"
        (click)="save()"
        [disabled]="form.invalid || isUploading() || isDeleting()"
        class="px-8 py-2 bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium rounded-md hover:bg-blue-700 transition"
      >
        {{ saveButtonText() }}
      </button>
    </div>
  </form>
</div>

@if (confirmingDelete()) {
  <app-confirm-dialog
    [busy]="isDeleting()"
    busyLabel="Deleting…"
    [error]="deleteError()"
    (confirmed)="confirmDelete()"
    (cancelled)="cancelDelete()"
  >
    <ng-container dialogTitle>Delete news article?</ng-container>
    The article and its images will be <span class="font-semibold text-red-600">permanently deleted</span>.
    This action cannot be undone.
  </app-confirm-dialog>
}
